// @flow
import { postCreator } from '../../common/http';
import environment from '../../environment';

export const endpoints = Object.freeze({
  ORDER_ITEM_HAS_ARRIVED: `${environment.apiUrl}/operations/progress-transactions/reception/arrived/:orderItemId`,
});

export const setOrderItemArrived = postCreator(fetch, endpoints.ORDER_ITEM_HAS_ARRIVED);
